import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom";
import { useGetConstructionDetails } from "../../helperHooks/getDetails";
import TopSection from "./Details/TopSection";
import DetailSection from "./Details/DetailSection";
import Gallery from "./Details/GallarySection";
import defaultImage from "../image/Image_not_available.png";

const ConstructionDetails = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const { data, loading, error } = useGetConstructionDetails();
  const project =
    data?.find((item) => String(item.id) === String(id)) || state || null;
  const baseImageBucketUrl = process.env.REACT_APP_S3_IMAGE_BUCKET_URL;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (loading && !project) {
    return (
      <Box sx={{ minHeight: "70vh", display: "grid", placeItems: "center" }}>
        <Typography color="text.secondary">Loading project details…</Typography>
      </Box>
    );
  }

  if (error && !project) {
    return (
      <Box sx={{ minHeight: "70vh", display: "grid", placeItems: "center", px: 3 }}>
        <Typography color="error">
          We couldn&apos;t load this project. Please try again later.
        </Typography>
      </Box>
    );
  }

  if (!project) {
    return (
      <Box sx={{ minHeight: "70vh", display: "grid", placeItems: "center" }}>
        <Typography variant="h4">Project not found</Typography>
      </Box>
    );
  }

  const image = project.image || project.projectImage;
  const gallery = project.details?.imageGallery || [];

  return (
    <Box sx={{ backgroundColor: "#f6f4ef" }}>
      <TopSection
        image={image ? `${baseImageBucketUrl}${image}` : defaultImage}
        title={project.title || project.projectTitle}
        typeOfBuilding={project.typeOfBuilding}
        projectType={project.projectType}
        status={project.status || project.projectStatus}
      />
      <DetailSection
        projectType={project.projectType}
        location={project.location}
        area={project.area}
        status={project.status || project.projectStatus}
        description={project.details?.description}
      />
      {gallery.length > 0 && <Gallery gallery={gallery} />}
    </Box>
  );
};

export default ConstructionDetails;
